import React, { Component } from 'react';

import { IS_VALID } from 'utils';

import Create from './Create';
import View from './View';

export default class FormContainer extends Component {
	render() {
		let {
			loadOptions,
			getRelation,

			actions,

			selectedData,
			formType,
		} = this.props;

		let createProps = {
			actions,

			loadOptions,
			getRelation,
		};

		let viewProps = {
			selectedData,

			getRelation,
		};

		switch (formType.toUpperCase()) {
			case 'UPDATE':
			case 'CREATE':
				return <Create {...createProps} />;
				break;
			case 'VIEW':
				return <View {...viewProps} />;
				break;
			case 'DELETE':
				return (
					<p>
						Are you sure you want to delete&nbsp;
						{IS_VALID(selectedData) && IS_VALID(selectedData.get('walletName')) ? (
							<span style={{ color: 'red' }}>{selectedData.get('walletName')}</span>
						) : (
							'this data'
						)}
						?
					</p>
				);
				break;
			default:
				return '';
				break;
		}
	}

	componentWillUnmount() {
		let { actions } = this.props;

		actions.setValue({
			selectedData: null,
			formType: '',
			formId: '',
			formTitle: '',

			image: null,
			imageSize: {
				label: 'Small',
				value: 'S',
			},
			walletCode: '',
			walletName: '',
			totalBalanceKey: '',
			earnedTodayKey: '',
			balanceKey: '',
			sort: 0,
			isShowDuration: false,
			durationStartDate: '',
			durationEndDate: '',
			isShowWallet: false,
			isHideZeroBal: false,
			isShowRedeem: false,
			isShowEarnedToday: false,
			isShowTotalBal: false,
			isShowHistory: false,

			cardType: [],
			excludedCardType: [],
			specificUser: [],
			blacklistedUser: [],
			deviceType: {
				label: 'All',
				value: 'ALL',
			},
			isUploadingCSVFile: false,
			isUploadingCSVFileBlacklistedUser: false,
		});
	}
}



// WEBPACK FOOTER //
// ./components/EWallet/FormContainer/index.js